import type { OperatorLifecycleState } from '@repo/types'

export type AppLaunchState = OperatorLifecycleState

const ONBOARDING_ALLOWED_PATHS = new Set(['/setup', '/services', '/integrations'])

export function deriveAppLaunchState({
  onboardingComplete,
  storedLaunchState,
}: {
  onboardingComplete: boolean
  storedLaunchState?: AppLaunchState | null
}): AppLaunchState {
  if (!onboardingComplete) {
    return 'onboarding_required'
  }

  if (storedLaunchState === 'go_live_pending_payment' || storedLaunchState === 'live_public') {
    return storedLaunchState
  }

  return 'onboarding_complete_private'
}

export function shouldRedirectOperatorToSetup({
  isAdmin,
  currentPath,
  onboardingError,
  onboardingLoading,
  launchState,
}: {
  isAdmin: boolean
  currentPath: string
  onboardingError: boolean
  onboardingLoading: boolean
  launchState: AppLaunchState
}): boolean {
  if (
    isAdmin ||
    ONBOARDING_ALLOWED_PATHS.has(currentPath) ||
    onboardingLoading ||
    onboardingError
  ) {
    return false
  }

  return launchState === 'onboarding_required'
}
